import { gql } from '@apollo/client';

export const GET_POSITIONS = gql`
  query GetPositions(
    $skip: Int = 0
    $take: Int = 1000
    $portfolioId: String!
    $institutionId: String
    $asOfDate: String
    $disposedRemoved: Boolean
  ) {
    positions(
      skip: $skip
      take: $take
      portfolioId: $portfolioId
      institutionId: $institutionId
      asOfDate: $asOfDate
      disposedRemoved: $disposedRemoved
    ) {
      positionId
      positionMasterId
      portfolioId
      institutionId
      brokerCode
      portfolioCode
      asOfDate
      isDummyCusip
      cusip
      description
      secGroup
      secClass
      secID
      pool
      ticker
      dealType
      country
      maturityDate
      wAMDate
      issueDate
      intAccrualDate
      firstCouponDate
      coupon
      couponDate
      couponFrequency
      paymentIntClass
      dayCountMethod
      poolType
      origFace
      origFacePrior
      currFace
      currFacePrior
      currFaceEnding
      factor
      pledgedAmount_Plugged
      cPR
      callDate
      callPrice
      callDays
      prerefundedDate
      prerefundedPrice
      bookPrice
      bookPriceOrig
      bookPricePrior
      bookPricePriorOrig
      bookYield
      bookYieldPrior
      bookValue
      bookValuePrior
      bookBEEM
      marketPrice
      marketPricePrior
      marketYield
      marketDiscount
      marketValue
      marketValuePrior
      acctgCPR
      acctgPSA
      fAS115
      gainLoss
      gainLossPrior
      taxStatus
      lifeCap
      lifeFloor
      periodicCollar
      lastResetDate
      nextResetDate
      resetFrequency
      margin
      fIC
      wAC
      wAM
      wALA
      origTerm
      stateCode
      marketYield_ToMaturity
      marketYield_ToCall
      marketYield_ToWorst
      marketYield_ToSink
      marketYield_TE_ToMaturity
      marketYield_TE_ToCall
      marketYield_TE_ToWorst
      marketYield_TE_ToSink
      bookYield_ToMaturity
      bookYield_ToCall
      bookYield_ToWorst
      bookYield_ToSink
      bookYield_TE_ToMaturity
      bookYield_TE_ToCall
      bookYield_TE_ToWorst
      bookYield_TE_ToSink
      bookYield_Static_ToMaturity
      bookYield_Static_ToCall
      bookYield_Static_ToWorst
      purchasePrice
      purchaseYield
      purchaseDate
      disposedRemoved
      disposedTransCode
      disposedDate
      disposedTradeDate
      disposedFactor
      disposedFactorDate
      disposedCoupon
      disposedSpeed
      disposedOrigFace
      disposedPrincipal
      disposedInterest
      disposedGainLoss
      paydownPrincipal
      paydownGainLoss
      nextPrincipalPayment
      yTM
      yTC
      isDailyPriced
      acctgYield
      acctgYield_TE
      acctgAvgLife
      acctgAvgLifePrior
      acctgDur
      acctgDurPrior
      acctgPricedTo
      acctgAmortAdjusted
      acctgAmort
      acctgAmortYtdPrior
      acctgAmort_LTD
      acctgAmort_Remaining
      interestAccrued
      interestAccruedYtdPrior
      interestPayment
      interestPaymentYtdPrior
      interestReceivable
      principalPurchased
      principalDisposed
      userNotes
      reportNotes
      transCode
      createdDt
      createdBy
      modifiedDt
      modifiedBy
      apmRptSecClass
      isDeleted
      rating {
        spRating
        moodyRating
      }
      lsegUniversalAskPrice
      lsegUniversalBidPrice
      safeKeepingPledgedSum
      safeKeepingPositions {
        recId
        positionMasterId
        safekeepingCode
        pledgeCode
        pledgedAmount
        pledgee {
          pledgeeName
          pledgeCode
        }
        currFace
      }
    }
  }
`;
